module.exports = __webpack_public_path__ + "img/login-bg.d9e25d0e.svg";